/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { FullSummaryItem } from './FullSummaryItem'
import {
  FullSummaryItemFromJSON,
  FullSummaryItemFromJSONTyped,
  FullSummaryItemToJSON,
} from './FullSummaryItem'

/**
 *
 * @export
 * @interface SummaryResult
 */
export interface SummaryResult {
  /**
   *
   * @type {Array<FullSummaryItem>}
   * @memberof SummaryResult
   */
  summaryItems?: Array<FullSummaryItem> | null
}

/**
 * Check if a given object implements the SummaryResult interface.
 */
export function instanceOfSummaryResult(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function SummaryResultFromJSON(json: any): SummaryResult {
  return SummaryResultFromJSONTyped(json, false)
}

export function SummaryResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SummaryResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    summaryItems: !exists(json, 'summary_items')
      ? undefined
      : json['summary_items'] === null
      ? null
      : (json['summary_items'] as Array<any>).map(FullSummaryItemFromJSON),
  }
}

export function SummaryResultToJSON(value?: SummaryResult | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    summary_items:
      value.summaryItems === undefined
        ? undefined
        : value.summaryItems === null
        ? null
        : (value.summaryItems as Array<any>).map(FullSummaryItemToJSON),
  }
}
